import * as yup from 'yup';

export const Option = yup.object().shape({
  value: yup.string().required(),
});

export const OptionNulable = yup.object().shape({
  value: yup.string().nullable(),
});

const warehouseSchema = yup.object().shape({
  animal_event_product_id: yup.string().nullable(),
  barn_id: Option,
  product_amount_for_one: yup.object().shape({
    amount: yup.string(),
    unit: OptionNulable,
  }),
  product_amount_total: yup.string().required(),
  product_unit: Option,
});
const productSchema = yup.object().shape({
  product_category_id: Option,
  product_type_id: Option,
  product_id: Option,
  barns: yup.array().of(warehouseSchema),
});

export const schema = yup.object().shape({
  species: OptionNulable,
  barn_ldc_nr: OptionNulable,
  animal_id: OptionNulable,
  status: yup.string().required(),
  date: yup.date().required(),
  products: yup.array().of(productSchema),
  notes: yup.string().max(4000).nullable(),
  costs: yup.string(),
  file: yup.mixed(),
  purpose_and_place_of_use: yup.string(),
});
